import {
  AlignItems,
  ColorPreset,
  FontWeight,
  JustifyContent,
  Box,
  Text,
} from "@gocardless/flux-react";
import { motion } from "framer-motion";

interface LoaderProps {
  imgSrc: string;
  text: string;
}

export const Loader: React.FC<LoaderProps> = ({ imgSrc, text }) => (
  <Box
    layout="flex"
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.Center}
    flexDirection="column"
    height="100vh"
    bg={ColorPreset.BackgroundLight_02}
  >
    <img src={imgSrc} width={72.5} height={72.5} alt="loader icon" />
    <Box spaceAbove={2}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Text size={[6, null, null, 8]} weight={FontWeight.SemiBold}>
          {text}
        </Text>
      </motion.div>
    </Box>
  </Box>
);
